export default __webpack_public_path__ + "static/media/signin_banner_Hk.e1194aeb.jpg";